export const Marquee = ({ items, testId = "marquee" }) => {
  const row = [...items, ...items];
  return (
    <div
      data-testid={testId}
      className="relative overflow-hidden border-y border-black/10 bg-ink-surface py-5"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center whitespace-nowrap font-display text-sm font-bold uppercase tracking-[0.35em] text-coal/25"
              >
                <span className="px-8">{item}</span>
                <span className="h-1.5 w-1.5 rotate-45 bg-ember/60" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
